export enum ReportStatusType {
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
}
